module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/faq/add-edit-faq/add-edit-faq.component.css
// module id = 975
// module chunks = 1